import { render, staticRenderFns } from "./config.vue?vue&type=template&id=318e5e77&scoped=true&"
import script from "./config.vue?vue&type=script&lang=js&"
export * from "./config.vue?vue&type=script&lang=js&"
import style0 from "./config.vue?vue&type=style&index=0&id=318e5e77&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318e5e77",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('318e5e77')) {
      api.createRecord('318e5e77', component.options)
    } else {
      api.reload('318e5e77', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=318e5e77&scoped=true&", function () {
      api.rerender('318e5e77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/newTemplateMgr/components/temporaryTemplate/voiceRecordValueType/config.vue"
export default component.exports